import { render, staticRenderFns } from "./UserE_TransactionSetting.vue?vue&type=template&id=968cc4dc"
import script from "./UserE_TransactionSetting.vue?vue&type=script&lang=js"
export * from "./UserE_TransactionSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports